import React, { useContext } from 'react';
import Modal from '../../components/modal/modal';
import axiosInstance from '../../AxiosInstance';
import { toast, ToastTypes } from '../../components/toasts/toast/toast';
import MyContext from '../../MyContext';
import {
    afterInvoiceActionSuccess,
    detailFromError,
    rejectFailedResponse,
} from '../bus/afterInvoiceActionSuccess';

export default function PreApproveModal({ show, setter, invoice }) {
    const { user } = useContext(MyContext);

    const preApprove = () => {
        if (!user?.can_pre_approve_invoice) {
            toast('No tiene permiso para pre-aprobar facturas.', ToastTypes.ERROR);
            return;
        }
        axiosInstance
            .put(`bill_status/${invoice.id}/`, { status: 4 })
            .then(rejectFailedResponse)
            .then(() => {
                afterInvoiceActionSuccess(setter);
            })
            .catch((err) => {
                toast(detailFromError(err, 'No se pudo pre-aprobar la factura.'), ToastTypes.ERROR);
            });
    };

    return (
        <Modal show={show} setter={setter} onClick={() => preApprove()} name={'Pre-aprobar'} buttonName={'Pre-aprobar'}>
            <div className={'mb-3'}>
                ¿Confirmas la pre-aprobación del documento {invoice?.sn}? El envío a SUNAT y la aprobación definitiva se
                harán en un paso posterior.
            </div>
        </Modal>
    );
}
